import RelatedCertificates from './RelatedCertificates';
import RelatedCertificatedCardComponent from './RelatedCertificateCard';

export const RelatedCertificateCard = RelatedCertificatedCardComponent;

export default RelatedCertificates;
